var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96313 13.9262C8.80986 13.9262 10.581 13.1926 11.8868 11.8868C13.1926 10.581 13.9262 8.80986 13.9262 6.96312C13.9262 5.11639 13.1926 3.34529 11.8868 2.03945C10.581 0.733613 8.80986 0 6.96313 0C5.11639 0 3.34529 0.733613 2.03945 2.03945C0.733613 3.34529 0 5.11639 0 6.96312C0 8.80986 0.733613 10.581 2.03945 11.8868C3.34529 13.1926 5.11639 13.9262 6.96313 13.9262ZM18.1431 13.385C20.0331 13.385 21.5656 10.51 21.5656 6.9625C21.5656 3.415 20.0331 0.54125 18.1431 0.54125C16.2531 0.54125 14.7206 3.41625 14.7206 6.9625C14.7206 10.51 16.2531 13.385 18.1431 13.385ZM23.6531 12.7112C24.3906 12.7112 24.9869 10.1362 24.9869 6.9625C24.9869 3.78875 24.3894 1.215 23.6531 1.215C22.9156 1.215 22.3181 3.78875 22.3181 6.9625C22.3181 10.1375 22.9156 12.7112 23.6531 12.7112Z",
    fill: "#FFFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMf);
export default __webpack_public_path__ + "static/media/mf.6084cb3087d1966949bdc242e77a9ca0.svg";
export { ForwardRef as ReactComponent };